/**
 * dead-event + dead-cf lint rules — surface events with no entities and CFs
 * with no reads/writes. Often a sign that documentation was added before
 * the implementation landed, or the implementation was removed but the spec
 * wasn't updated.
 */
import type { AtlasManifest } from '../types.js';

export interface DeadFinding {
  ref: string;
  message: string;
}

export function deadEvent(manifest: AtlasManifest): DeadFinding[] {
  const findings: DeadFinding[] = [];
  for (const event of manifest.events) {
    if (event.carriedEntities.length === 0) {
      findings.push({
        ref: event.type,
        message: `Event ${event.type} carries no entities — consider linking it to the entity it acts on, or deleting if unused`,
      });
    }
  }
  return findings;
}

export function deadCloudFunction(manifest: AtlasManifest): DeadFinding[] {
  const findings: DeadFinding[] = [];
  for (const cf of manifest.cloudFunctions) {
    if (cf.reads.length === 0 && cf.writes.length === 0) {
      findings.push({
        ref: cf.name,
        message: `Cloud Function ${cf.name} has no documented reads or writes — schema-coverage gap`,
      });
    }
  }
  return findings;
}
